<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <p class="copyright text-center">
          &copy; 2022 Raefton
        </p>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// AppFooter.vue?7d1d853b